import React from 'react';
import { useIntl } from 'umi';
import {
  TopchartPageId,
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import {
  getDeviceValuesByPageId,
  getDeviceConfig,
  getDeviceOptionByType,
} from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import {
  commonPCConsoleDefaultFilterValue,
  handleDetailDigitalFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import PCUPhysicalDigital from '../index';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import {
  getDetailPageCfg,
  DETAIL_PAGEID,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import { COMPETITOR_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/Competitor';
import {
  statsTrend,
  statsCountriesTrend,
  statsCountriesTable,
} from '@/pages/intelligence/services/topcharts';

export default function DigitalRevenue(props: any) {
  const { entityType, gameId, pageId, tabType, gsdDevicesFlatten, gsdSegments, downloadModalSize, getRadioOptionsTips } =
    props;

  const { formatMessage } = useIntl(); // 中英切换方法

  const defaultRegion = ['stats', 'countries'].includes(tabType) ? 'us' : 'global';

  const { filterLoading, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.digitalRevenue,
  });

  const defaultFilterValue = {
    ...commonPCConsoleDefaultFilterValue,
    [filterKeyMap.REGION]: {
      // regions: ['na'],
      regions: [],
      // markets: ['us'],
      markets: [defaultRegion],
      type: 'region',
    },
    [filterKeyMap.DIGITAL_SEGEMENT]: {
      value: 'All',
    },
    [filterKeyMap.DIGITAL_DEVICE]: {
      value: getDeviceValuesByPageId(TopchartPageId.DigitalRevenue, entityType),
    },
  };
  const hasDevice = entityType === 'console' || entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE;

  const filterKeyList = [
    filterKeyMap.RANGE_TIME,
    filterKeyMap.REGION,
    filterKeyMap.DIGITAL_SEGEMENT,
  ];
  if (hasDevice) {
    filterKeyList.push(filterKeyMap.DIGITAL_DEVICE);
  }

  const filterCfg = {
    filterKeyList,
    regionFilterParams: {},
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
    },
    specialParams: {
      regionOptions, // 国家筛选器options,
      getRadioOptionsTips,
      defalutMarket: [defaultRegion], // 没取到交集用的默认值
      disableNoChina: true,
      rangeTimeType: FilterTimeType.commonRange,
      // disableIegg: false,
      // disableAnnie: true,
      isShowAlloftime: false,
      digitalSegementGuideClassName: COMPETITOR_GUIDE_CLASSNAMES.ELEMENT5,
      digitalDeviceOptions: getDeviceOptionByType(TopchartPageId.DigitalRevenue, entityType),
      [filterKeyMap.DIGITAL_DEVICE]: {
        useCascaderStyle: true,
      },
      entityType,
      showRadioBubble: true,
    },
    showConfirmButton: false,
    haveFilterSaveBtn: false,
    handleFilterToApiParams: handleDetailDigitalFilterParamsToApi,
  };

  const deviceDefVales = getDeviceConfig(pageId, entityType)?.value;
  const pageCfg = getDetailPageCfg(pageId, tabType, entityType);
  const defaultByDeviceVal = pageCfg?.defaultByDeviceVal || undefined;
  const params = {
    source: 'mscience',
    tab_name: 'digital_revenue',
    regions: [defaultRegion],
    segment: 'All',
    sort_field: 'digitalRevenue',
    unified_id: gameId,
    entity_type: entityType,
    region_type: 'market',
    start_date: '',
    end_date: '',
    date_type: 'monthly',
    sort_type: 'desc',
    device: hasDevice ? deviceDefVales : undefined,
    b_group_by_device: defaultByDeviceVal,
    metric: ['digitalRevenue'],
  };

  return (
    <PCUPhysicalDigital
      {...props}
      // entityType={'console'}
      // pageId={pageId}
      // pageLogInfo={dbiPageLogMes.topChartsConsoleGamesDigitalRevenue}
      // tableCloumsList={digitalRevenueList}
      // hasRegionFilter={true}
      // cardMetricName={formatMessage({ id: 'dbi_digital_revenue' })}
      downloadModalSize={downloadModalSize}
      filterCfg={filterCfg}
      filterLoading={filterLoading}
      // rangeTimeComponentDefault={latestTimeTypeHasData}
      filterIcon={
        <TipContext
          AWidth={260}
          className="statsfilter-warp-filter-tip"
          tipText={formatMessage({
            id: tabType === 'stats' ? 'dbi_mscience_info' : 'dbi_mscience_global_info',
          })}
        />
      }
      pageCfg={pageCfg}
      pageParameters={params}
      // releaseInFortyDay={false}//GSD这里因为是周粒度，所以这里配置为false不让它为日粒度
      metricKey={DETAIL_PAGEID.digitalRevenue}
      gsdDevicesFlatten={gsdDevicesFlatten}
      gsdSegments={gsdSegments}
      getTrendsFun={statsTrend}
      getMarketTrendsFun={statsCountriesTrend}
      getMarketTableFun={statsCountriesTable}
      // lineSourceName={entityType !== PC_CONSOLE_COMBINE_ENTITY_TYPE ? formatMessage({ id: `dbi_${entityType}` }) : null}
      getRadioOptionsTips={getRadioOptionsTips}
    />
  );
}
